import { create } from 'zustand'
import { WIALON_DEFAULT_URL } from '@/shared/config/systemUrls'

interface WialonState {
  token: string
  setToken: (token: string) => void
  url: string
  setUrl: (url: string) => void
}

export const useWialonStore = create<WialonState>()((set) => ({
  token: '',
  setToken: (token: string) => set({ token }),
  url: WIALON_DEFAULT_URL,
  setUrl: (url: string) => set({ url }),
}))
